import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Row, Col } from 'antd'
import Link from 'next/link'
import PropTypes from 'prop-types'

import { getChildrenToRender } from 'shared/util'

const dataSource = (allSoftwares) => {
  return {
    wrapper: { className: 'home-page-wrapper content0-wrapper' },
    page: { className: 'home-page content0' },
    OverPack: { playScale: 0.3 },
    titleWrapper: {
      className: 'feature7-title-wrapper',
      children: [
        {
          name: 'title',
          className: 'feature7-title-h1',
          children: 'Popular Stock software',
        },
      ],
    },
    blockWrapper: {
      className: 'feature7-block-wrapper',
      gutter: 24,
      children: allSoftwares.map((software, idx) => {
        const {
          attributes: { slug, name, details },
        } = software

        return {
          md: 6,
          xs: 24,
          name: `block${idx}`,
          className: 'feature7-block',
          children: {
            className: 'feature7-block-group',
            href: '/software/[slug]',
            as: `/software/${slug}`,
            children: [
              {
                name: 'image',
                className: 'feature7-block-image',
                children: (
                  <img
                    alt="CalIcon"
                    src="https://gw.alipayobjects.com/zos/rmsportal/ruHbkzzMKShUpDYMEmHM.svg"
                    width="16"
                    height="16"
                  />
                ),
              },
              {
                name: 'title',
                className: 'feature7-block-title',
                children: name,
              },
              {
                name: 'content',
                className: 'feature7-block-content',
                children: (
                  <ReactMarkdown>
                    {details.split(' ', 10).join(' ')}
                  </ReactMarkdown>
                ),
              },
            ],
          },
        }
      }),
    },
  }
}

function FeatSoftware(props) {
  const { isMobile, allSoftwares, ...tagProps } = props
  const CalculatorDatasource = dataSource(allSoftwares)
  const { blockWrapper, titleWrapper } = CalculatorDatasource

  if (blockWrapper.children.length === 0) {
    return null
  }

  const childrenToRender = blockWrapper.children.map((item, i) => {
    return (
      <Col {...item} key={i.toString()}>
        <Link
          href={item.children.href}
          as={item.children.as}
          className={item.children.className}
        >
          {item.children.children.map(getChildrenToRender)}
        </Link>
      </Col>
    )
  })

  return (
    <div {...tagProps} {...CalculatorDatasource.wrapper}>
      <div {...CalculatorDatasource.page}>
        <div {...CalculatorDatasource.titleWrapper}>
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <Row gutter={[24, 24]}>{childrenToRender}</Row>
      </div>
    </div>
  )
}

FeatSoftware.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  allSoftwares: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      details: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default FeatSoftware
